export default () => ({
  show: false,
  statusAddress: null,
  statusStaff: null,
  statusPrice: null,
  wasRaised: false,
  beenUpdated: false,
  specialities: [],
  optionsSpecialities: [],
  optionsCompanyAddress: [],
  optionsCovenants: [],
  optionsCompanyProfessional: [],
  optionsCompanyProfessionalSpecialities: [],
  optionsProfessionalSpecialities: [],
  agenda: {
    id: null,
    company_id: null,
    company_address_id: null,
    professional_id: null,
    specialities: [],
    address: null,
    covenants: [],
    name: null,
    screening: true,
    callcenter: true,
    active: true,
    public: true,
    kind: 'attendance',
    service_network: 'all'
  },
  includes: [
    'address',
    'specialities',
    'covenants',
    'professional'
  ],
  searchText: true,
  convenantHidden: true,
  agendaIsPrivate: false
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/form/resources/data.js